import React from 'react'
import { sanitize } from 'dompurify'

const TitleAndDescr = ({ title, description, html }) => (
  <div className="App-title-and-description" >
    { (title && description || title && html) && <h3>{title}</h3> }
    { title && description && <p>{description}</p> }
    { title && html && <span dangerouslySetInnerHTML={{__html: sanitize(html)}}></span>}
  </div>
)

export default TitleAndDescr;